import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo, useCallback } from 'react';
import isEqual from 'react-fast-compare';

import type {
    CatalogCardType,
    HorizontalCatalogCardType,
    PreviewCatalogCardType,
} from '@/components/CatalogCard/Cards';

import CatalogVisibilityWrapper from '@/components/CatalogCard/CatalogVisibilityWrapper';

type Props = {
    CardComponent?: CatalogCardType | HorizontalCatalogCardType | PreviewCatalogCardType;
    catalogCardClass?: string;
    catalogIds: number[];
    className?: string;
    horizontal?: boolean;
    lazyLoadImages?: boolean;
    previewSellerId?: number;
    testid?: string;
    trackClick?: (id: number) => void;
};

const AuctionsNearMeCatalogGrid = ({
    CardComponent,
    catalogCardClass = 'catalog-card',
    catalogIds,
    className,
    horizontal = false,
    lazyLoadImages,
    testid,
    trackClick,
}: Props) => {
    const mapCatalogCards = useCallback(
        (catalogId: number, index: number) => {
            const cardProps: any = {
                catalogId,
                horizontal,
                lazyLoadImages: !lazyLoadImages && index < 6 ? false : true,
                trackClick,
            };

            if (CardComponent) {
                return (
                    <CardComponent
                        className={catalogCardClass}
                        key={`${catalogId}-catalog-grid-card`}
                        {...cardProps}
                    />
                );
            }

            return (
                <div
                    className={catalogCardClass}
                    data-testid="catalogCardWrapper"
                    key={`${catalogId}-catalog-grid-card`}
                >
                    <CatalogVisibilityWrapper {...cardProps} />
                </div>
            );
        },
        [catalogCardClass, horizontal, lazyLoadImages, CardComponent, trackClick]
    );

    return (
        <div
            className={cn('grid gap-sm smMin:grid-cols-2', className)}
            data-testid={testid}
        >
            {catalogIds.map(mapCatalogCards)}
        </div>
    );
};

export default memo<Props>(AuctionsNearMeCatalogGrid, isEqual);
